import { Menu, Scale, X } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FontSizeToggle from '../FontSizeToggle.jsx'
import LanguageSwitcher from '../LanguageSwitcher.jsx'
import ThemeToggle from '../ThemeToggle.jsx'

const AppHeader = ({ onHome }) => {
	const { t } = useTranslation('common')
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
	const menuRef = useRef(null)

	useEffect(() => {
		if (!isMobileMenuOpen) return undefined

		const handleOutside = e => {
			if (menuRef.current && !menuRef.current.contains(e.target)) setIsMobileMenuOpen(false)
		}
		const handleKeyDown = e => {
			if (e.key === 'Escape') setIsMobileMenuOpen(false)
		}

		document.addEventListener('mousedown', handleOutside)
		document.addEventListener('keydown', handleKeyDown)
		return () => {
			document.removeEventListener('mousedown', handleOutside)
			document.removeEventListener('keydown', handleKeyDown)
		}
	}, [isMobileMenuOpen])

	return (
		<header className='main-header'>
			<div className='logo-block'>
				<div className='logo-icon-badge' aria-hidden='true'>
					<Scale size={20} />
				</div>
				<div className='logo-text-col'>
					<button
						type='button'
						className='logo-title-btn'
						onClick={() => {
							setIsMobileMenuOpen(false)
							onHome()
						}}
					>
						<h1 className='logo'>{t('appTitle')}</h1>
					</button>
					<span className='free-offer-text'>
						{t('header.freeOfferPrefix')}{' '}
						<a href='https://mertens-rechtsanwalt.de' target='_blank' rel='noopener noreferrer'>
							Rechtsanwalt Richard Mertens, LL.M.
						</a>
					</span>
				</div>
			</div>
			<div className='header-controls' ref={menuRef}>
				<div className='header-settings-group'>
					<LanguageSwitcher />
					<span className='header-settings-divider' aria-hidden='true' />
					<FontSizeToggle />
					<span className='header-settings-divider' aria-hidden='true' />
					<ThemeToggle />
				</div>

				<button
					type='button'
					className='menu-toggle-btn'
					aria-label={t(isMobileMenuOpen ? 'header.closeMenu' : 'header.openMenu')}
					aria-expanded={isMobileMenuOpen}
					onClick={() => setIsMobileMenuOpen(prev => !prev)}
				>
					{isMobileMenuOpen ? <X size={22} /> : <Menu size={22} />}
				</button>

				{isMobileMenuOpen && (
					<div className='mobile-menu-panel'>
						<LanguageSwitcher onSelect={() => setIsMobileMenuOpen(false)} />
						<FontSizeToggle />
						<ThemeToggle />
					</div>
				)}
			</div>
		</header>
	)
}

export default AppHeader
